module.exports = __webpack_public_path__ + "img/position_DM.ad5a26b3.png";